import mixins from 'common/mixins.js'

export default {
  props: {
    userPermissionModules: { type: Array, default: () => [] },
    conversation_id: { type: String, default: '' }
  },
  mixins: [mixins.requests],
  methods: {
    get_tirantcloud_token() {
      let params = {
        folder_path: gon.app_tolgeo+'/'+gon.session_id,
        storage_type: 'temp'
      }

      return this.getServiceToken('tirantcloud', params)
    },
    conversaOptions(fromWorkspace = false) {
      return {
        config: {
          endPoint: gon.sofia_service_url + '/',
          getTokenFunction: this.getToken,
          locale: I18n.locale,
          materia: gon.materia_url_param || '',
          paisiso: gon.paisiso,
          isPersonalized: gon.subscription_id != undefined,
          personalizedUserID: this.personalizedUserID(),
          globalUserID: gon.user_id,
          currentApp: gon.current_app,
          userHasConversa: gon.user_has_conversa,
          environment: gon.environment,
          recoverConversationId: this.conversation_id,
          fromWorkspace: fromWorkspace,
          baseEndpoint: gon.cloud_service_url,
          tcsTokenFunction: this.get_tirantcloud_token,
          session_id: gon.session_id || null,
          tolgeo: gon.app_tolgeo
        }
      }
    },
    personalizedUserID(){
      return gon.subscription_id || 'not_personalized'
    },
    async getToken() {
      return this.getServiceToken('sofia', { permissions: ['sofia', 'conversa'] })
    }
  }
}
